import types from '../../../mutation-types';

const DEFAULT_CONVERSATIONS_PER_PAGE = 25;
const DEDUPE_THREAD_ROWS = true;

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch(
    'conversationPage/setCurrentPage',
    { filter, page: page || 1 },
    { root: true }
  );
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const countNewThreadRows = (conversationList, existingConversations) => {
  const existingContactInboxIds = new Set(
    existingConversations
      .filter(conversation => conversation.contact_inbox_id)
      .map(conversation => conversation.contact_inbox_id)
  );

  return conversationList.filter(
    conversation =>
      conversation.contact_inbox_id &&
      !existingContactInboxIds.has(conversation.contact_inbox_id)
  ).length;
};

export const shouldMarkConversationListEnd = ({
  conversationList,
  metaData = {},
  existingConversations = [],
  dedupeThreadRows,
}) => {
  if (!conversationList.length) {
    return true;
  }

  if (
    dedupeThreadRows &&
    countNewThreadRows(conversationList, existingConversations) === 0
  ) {
    return true;
  }

  if (typeof metaData.has_more === 'boolean') {
    return !metaData.has_more;
  }

  const perPage = metaData.per_page || DEFAULT_CONVERSATIONS_PER_PAGE;

  if (conversationList.length < perPage) {
    return true;
  }

  return false;
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { replaceExisting = false, countRequest } = {}
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  const existingConversations = context.rootGetters.getAllConversations || [];
  const listPayload = {
    conversationList,
    dedupeThreadRows: DEDUPE_THREAD_ROWS,
  };
  if (replaceExisting) {
    context.dispatch('conversationPage/reset', null, { root: true });
    context.commit(types.REPLACE_CONVERSATION_LIST, listPayload);
  } else {
    context.commit(types.SET_ALL_CONVERSATION, listPayload);
  }
  context.dispatch('conversationStats/set', {
    meta: metaData,
    request: countRequest,
  });
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: shouldMarkConversationListEnd({
      conversationList,
      metaData,
      existingConversations,
      dedupeThreadRows: DEDUPE_THREAD_ROWS,
    }),
  });
};
